import { CREATE_SHIPPING_METHOD, GET_SHIPPING_METHODS } from './ApiConstants';
import api from './ApiHandler';

export const getShippingMethodsByPage = async (payload: any) => {
  return await api.get(GET_SHIPPING_METHODS, { params: { ...payload } });
};

export const createShippingMethods = async (payload: any) => {
  return await api.post(CREATE_SHIPPING_METHOD, { ...payload });
};
